/**
 * Created by manoraj.k on 17/08/17.
 */
import styled from "styled-components";
import {colors} from "../../colorCodes";

export const TabContainer = styled.div`

        `

export const PanelTabsContainer = styled.div`
.show {
display: block;
}
.hide {
display: none;
}

        `

export const PanelContainer = styled.div`

        `
export const VerticalTabsContainer = styled.div`

        `

export const HorizontalTabsContainer = styled.div`
.rc-tab {
display: inline-block;
}
        `